import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";

const initialState = {
    groupGuid: "",
    user: {},// {IsAdmin:true/false, AuthToken:"", GroupGuid:"", RequirePasswordChange:true/false }
    mainUser: {}, // {IsAdmin:true/false, AuthToken:"", GroupGuid:"", RequirePasswordChange:true/false }
    behalfOfUser: {},// {IsAdmin:true/false, AuthToken:"", GroupGuid:"", RequirePasswordChange:true/false }
    status: 'idle', // idle loading success fail  
    statusBehalf: 'idle', // idle loading success fail  
    error: null,
    errorBehalf: null,
    statusSwitch: 'idle',

}
/**
 * 
 * const { user: currentUser } = useSelector((state) => state.auth);
 */
const WELLSUITE = '../../WsWebServiceWellSuite/'
const PLATFORM = '../../WsWebServicePlatform/'
const HRA = '../../WsWebServiceHra/'
const WEBAPP = '../../WsWebAppWellSuite';


export const userLogin = createAsyncThunk('auth/login', async (incomingVariable, thunkAPI) => {

    const bodies = {
        ParamData: {
            GroupGuid: incomingVariable.GroupGuid
            , Username: incomingVariable.Username
            , Password: incomingVariable.Password
        }
    }
    try {
        const response = await axios.post(PLATFORM + "Login", bodies)
        //console.log(response.data)
        const Lang = await response?.data?.Info 
                    && response.data.Info.length > 0
                    && response.data.Info[0].AuthToken
                    && incomingVariable.language
                    && incomingVariable.language !='-1'
                    
                    && axios.post(PLATFORM
                    + "Participant/SessionVar/Set/"
                    + response.data.Info[0].AuthToken + "/"
                    + "LANGUAGE" + "/"
                    + incomingVariable.language + "/"

                    || true

                )
                //console.log(Lang.data)    
        const uom = await response?.data?.Info
                && response.data.Info.length > 0
                && response.data.Info[0].AuthToken
                && incomingVariable.unitofmeasure
            &&
                axios.post(PLATFORM
                    + "Participant/SessionVar/Set/"
                    + response.data.Info[0].AuthToken + "/"
                    + "QUESTION%20UOM%20TEMPLATE" + "/"
                    + incomingVariable.unitofmeasure + "/"

                )
            || true
            //console.log(uom.data)    
  
      
        const data = await response.data

        return [await data, await Lang, await uom]
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

//Admin/Participant/Login/{AuthToken}/{ParticipantGuid}/
export const userLoginBehalfOf = createAsyncThunk('auth/loginBehalfOf', async (incomingVariable, thunkAPI) => {


    try {
        const response = await axios.post(PLATFORM + "Admin/Participant/Login/" + incomingVariable.AuthToken + "/" + incomingVariable.ParticipantGuid + "/")
        const data = await response.data

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

export const userLogout = createAsyncThunk('auth/logout', async (incomingVariable, thunkAPI) => {
    const state = thunkAPI.getState()


    const { mainUser, behalfOfUser } = state.auth
    //
    // when logout is called, log out of behalf of if availble
    //
    const isBehalfOf = behalfOfUser && behalfOfUser.AuthToken ? true : false
    const AuthTokenToUse = isBehalfOf ? behalfOfUser.AuthToken : mainUser.AuthToken

    try {
        const response = await axios.post(PLATFORM + "Logout/" + AuthTokenToUse + "/")
        const data = await response.data

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})



const authSlice = createSlice({
    name: 'auths',
    initialState,
    reducers: {
        authClear(state, action) {

            state.status = "idle"
            state.statusBehalf = "idle"
            state.error = null
            state.errorBehalf = null
            state.user = {}
            state.mainUser = {}
            state.behalfOfUser = {}
            state.timeoutRemaining = 0
            state.isTimedOut = false
        },
        setSAMLLogin(state, action) {

            state.status = "success"
            state.mainUser = { ...action.payload }
            state.user = { ...action.payload }
            state.error = null
            state.isTimedOut = false
        },
        updateUserPWState(state, action) {
            state.user = { ...state.user, PasswordChangeRequired: action.payload }
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(userLogin.pending, (state, action) => {
                state.status = 'loading'
                state.error = null
            })
            .addCase(userLogin.fulfilled, (state, action) => {
   
                const Success = action.payload[0].Success

                if (Success === true) {
                    state.status = 'success'
                    const loadedData = action.payload[0].Info[0]
                    state.groupGuid = action.meta.arg.GroupGuid
                    state.mainUser = { ...loadedData, GroupGuid: action.meta.arg.GroupGuid }
                    state.user = { ...loadedData, GroupGuid: action.meta.arg.GroupGuid }
                    state.error = null
                    state.isTimedOut = false

                } else {
                    state.status = 'failed'
                    state.error = action.payload[0].Status[0]
                }
            })
            .addCase(userLogin.rejected, (state, action) => {
                state.error = action.error.message

            })

            //////////////////
            //////////////////
            //////////////////

            .addCase(userLoginBehalfOf.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(userLoginBehalfOf.fulfilled, (state, action) => {
                const Success = action.payload.Success
                state.statusSwitch = 'loading'
                if (Success === true) {
                    state.status = 'success'
                    state.statusBehalf = 'success'
                    state.statusSwitch = 'success'
                    state.errorBehalf = null
                    const loadedData = action.payload.Info[0]
                    state.behalfOfUser = { ...loadedData, GroupGuid: action.meta.arg.GroupGuid, ParticipantGuid: action.meta.arg.ParticipantGuid }
                    state.user = { ...loadedData, GroupGuid: action.meta.arg.GroupGuid, ParticipantGuid: action.meta.arg.ParticipantGuid }

                } else {
                    state.statusBehalf = 'failed'
                    state.statusSwitch = 'failed'
                    state.errorBehalf = action.payload.Status[0]
                }
            })
            .addCase(userLoginBehalfOf.rejected, (state, action) => {
                state.error = action.error.message

            })

            //////////////////
            //////////////////
            //////////////////

            .addCase(userLogout.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(userLogout.fulfilled, (state, action) => {

                //
                // when logout is called, log out of behalf of if availble
                //

                const isBehalfOf = state.behalfOfUser && state.behalfOfUser.AuthToken ? true : false
                state.statusSwitch = 'loading'
                const Success = action.payload.Success
                if (Success === true) {
                    state.error = null
                    if (isBehalfOf === true) {
                        state.user = state.mainUser
                        state.behalfOfUser = {}
                        state.statusBehalf = "idle"
                        state.status = 'success'
                        state.statusSwitch = 'success'
                        state.errorBehalf = null

                    } else {
                        state.mainUser = {}
                        state.behalfOfUser = {}
                        state.user = {}
                        state.status = "idle"
                        state.statusBehalf = "idle"
                        state.statusSwitch = 'idle'
                        state.errorBehalf = null
                        state.error = null
                        state.timeoutRemaining = 0
                        state.isTimedOut = false

                    }
                } else {
                    state.status = "failed"
                    state.error = action.payload.Status[0]
                }

            })
            .addCase(userLogout.rejected, (state, action) => {
                state.error = action.error.message

            })



    }
})

export const { authClear, setSAMLLogin, updateUserPWState } = authSlice.actions

export default authSlice.reducer

const selectAuthEntities = (state) => state.auths.entities

export const selectAuths = createSelector(selectAuthEntities, (entities) =>
    Object.values(entities)
)

export const selectAuthById = (state, AuthId) => {
    return selectAuthEntities(state)[AuthId]
}

